import requestSender from "./base/requestSender";

export default function(axiosInstance){
    return {
        getTaskManager(payload){
            return requestSender('post', 'tasks/get-tasks-by-category-and-manager', payload);
        },
        getAnswerTaskCall(payload){
            return requestSender('post', 'tasks/get-tasks-answers-by-call-info-id', payload);
        },

    }
}